import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { PreChartLabsForm } from "@/components/ui/visits/pre-chart/PreChartLabsForm";
import {
  readAccountLabs,
  usePreChartLabsVersion,
  writeAccountLabs,
} from "@/lib/pre-chart-labs";
import { useAuthStore } from "@/store/auth.store";

// Settings → Pre-chart: "Pre-chart labs", which lab values every pre-chart
// takes from lab reports (one pre-chart can override it from its banner).
// Saved as it changes, in this browser.
export const PreChartSettings = (): JSX.Element => {
  const { t } = useTranslation();
  usePreChartLabsVersion();
  const account = useAuthStore((state) => state.userData?.public_id);
  return (
    <div className="space-y-3 font-v3" data-testid="pre-chart-settings">
      <h3 className="text-[15px] font-semibold text-v3-text">
        {t("preChart.labs.title")}
      </h3>
      <p className="text-[14px] leading-5 text-v3-text-2">
        {t("preChart.labs.settingBody")}
      </p>
      <PreChartLabsForm
        value={readAccountLabs(account)}
        onChange={(value) => writeAccountLabs(account, value)}
      />
      <p className="text-[12.5px] leading-[17px] text-v3-text-3">
        {t("preChart.labs.savedHere")}
      </p>
    </div>
  );
};
